import { useAtom } from '@reatom/npm-react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { CurrencyModel } from '@root/entities/currency'
import { WalletModelShort } from '@root/entities/wallet/ui'
import { WalletAddressTruncated } from '@root/entities/wallet/ui/common/wallet-address-truncated'
import { AmountFormatted } from '@root/shared/core/format'

import type { WalletModel } from '@root/entities/wallet/atoms'

type Props = {
  wallet: WalletModel | undefined
}

export const PaymentDialogWallet: React.FC<Props> = ({ wallet }) => {
  const { t } = useTranslation()

  if (!wallet) {
    return <Root>{t('premium.pay.no-wallet')}</Root>
  }

  return <PaymentDialogWallet_ wallet={wallet} />
}

const PaymentDialogWallet_ = ({ wallet }: { wallet: WalletModel }) => {
  const currency = CurrencyModel.nativeOf(wallet.network)
  const [balanceNative] = useAtom(wallet.nativeAssetBalance)

  return (
    <Root>
      <WalletShortAddress wallet={wallet} size="xs" />
      <WalletAddress walletAddress={wallet.address} />
      <AmountNative>
        <AmountFormatted
          currency={currency.ticker}
          amount={balanceNative}
          roundingMode="trunc"
        />
      </AmountNative>
    </Root>
  )
}

const Root = styled.span`
  display: grid;
  grid-template-columns: auto 1fr auto;
  padding-inline-start: 10px;

  text-align: left;
  font-size: 11px;
  font-weight: 600;

  align-content: center;
  align-items: center;
  justify-content: space-between;
  justify-items: center;
`

const WalletShortAddress = styled(WalletModelShort)`
  --wallet-short-indicator-size: 3px;
`

const Amount = styled.span`
  color: var(--text-12);

  font-size: 11px;
  font-weight: 600;

  display: grid;
  grid-template-columns: auto auto;
  justify-content: space-between;
`

const AmountNative = styled(Amount)`
  color: var(--text-12);
`

const WalletAddress = styled(WalletAddressTruncated)`
  color: var(--text-8);

  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
`
